const _ = require('underscore');

const { randomString } = require('sma.common/utils');

var templates = {
	body: require('sma.common/components/select/partials/multiselect_body.mustache'),
	groupContainer: require('sma.common/components/select/partials/multiselect_group.mustache'),
	item: require('sma.common/components/select/partials/multiselect_item.mustache')
};

class MultiSelect {
	constructor(config) {
		if (config === undefined) {
			config = {};
		}

		this.element = $(templates.body({
			strings: {
				search: gettext('Search...')
			}
		}));

		this.groupCounter = 0;

		this.items = [];

		if (config.items !== undefined) {
			this._parseItems(config.items);
		}

		if (config.appendTo !== undefined) {
			this.element.appendTo(config.appendTo);
		}

		let noop = () => {};

		this.callbacks = {
			itemSelected: config.itemSelected || noop,
			itemDeselected: config.itemDeselected || noop,
			selectionChanged: config.selectionChanged || noop
		};

		//options to add
		// + show selection count
		// + show or hide search
		// + confirm buttons
		// + popup mode

		this.bindEvents();
	}

	get $items() {
		return this.element.find('.sma-select-multi-items');
	}

	get $searchContainer() {
		return this.element.find('.sma-select-multi-search-container');
	}

	get $searchInput() {
		return this.element.find('input.sma-select-multi-search');
	}

	bindEvents() {
		this.$searchInput.on('input', _.debounce($.proxy(this._searchInput, this), 100));

		this.element.on('change', 'input[type="checkbox"]', $.proxy(this._selectionChanged, this));
	}

	_selectionChanged(e) {
		let target = $(e.currentTarget);
		let item = this.getItemByValue(target.val());

		if (target.is(':checked')) {
			this.callbacks.itemSelected(this, item);
		} else {
			this.callbacks.itemDeselected(this, item);
		}

		this.callbacks.selectionChanged(this);
	}

	_searchInput(e) {
		if (this.$searchInput.val().trim().length > 0) {
			this.search(this.$searchInput.val().trim());
		} else {
			this.clearSearch();
		}
	}

	_parseItems(items) {
		for (let item of items) {
			if (item.hasOwnProperty('items')) {
				let composedGroup = this._buildGroup(item);

				this._pushItem(composedGroup);
			} else {
				let composedItem = this._buildItem(item);

				this._pushItem(composedItem);
			}
		}
	}

	_pushItem(item) {
		this.$items.append(item.element);
		this.items.push(item);
	}

	_pushItemToGroup(item, group) {
		group.element.find('.sma-select-multi-group-items').append(item.element);
		group.items.push(item);
	}

	_buildGroup(group) {
		let groupElement = $(templates.groupContainer(group));

		this.groupCounter++;

		let composedGroup = {
			element: groupElement,
			isGroup: true,
			label: group.label,
			key: group.key || this.groupCounter,
			items: []
		};

		for (let item of group.items) {
			let composedItem = this._buildItem(item);

			this._pushItemToGroup(composedItem, composedGroup);
		}

		return composedGroup;
	}

	_buildItem(item) {
		let itemWithUid = Object.assign({}, item);
		itemWithUid.uid = randomString(10) + item.value.toString();

		let itemElement = $(templates.item(itemWithUid));

		return {
			element: itemElement,
			isGroup: false,
			label: item.label,
			value: item.value
		};
	}

	getSelectedCount() {
		return this.$items.find('input[type="checkbox"]:checked').length;
	}

	getSelectedItems() {
		let selected = [];

		for (let item of this.items) {
			if (item.isGroup) {
				for (let groupItem of item.items) {
					if (groupItem.element.find('input').is(':checked')) {
						selected.push(groupItem);
					}
				}
			} else {
				if (item.element.find('input').is(':checked')) {
					selected.push(groupItem);
				}
			}
		}

		return selected;
	}

	getGroup(key) {
		for (let item of this.items) {
			if (item.isGroup && item.key == key) {
				return item;
			}
		}

		return null;
	}

	getSelectedValues() {
		return this.getSelectedItems().map((i) => { return i.value; });
	}

	addItem(item, groupKey) {
		let composedItem = this._buildItem(item);

		if (groupKey !== undefined) {
			let group = this.getGroup(groupKey);

			if (group != null) {
				this._pushItemToGroup(item, group);
			}
		} else {
			this._pushItem(composedItem);
		}
	}

	getItemByValue(value) {
		for (let item of this.items) {
			if (item.isGroup) {
				for (let groupItem of item.items) {
					if (groupItem.value == value) {
						return groupItem;
					}
				}
			} else {
				if (item.value == value) {
					return item;
				}
			}
		}

		return null;
	}

	disableItem(value) {
		let item = this.getItemByValue(value);

		if (item == null) return;

		item.element.find('.custom-control').addClass('disabled');
		item.element.find('input').attr('disabled', 'disabled');
	}

	enableItem(value) {
		let item = this.getItemByValue(value);

		if (item == null) return;

		item.element.find('.custom-control').removeClass('disabled');
		item.element.find('input').removeAttr('disabled');
	}

	hideItem(value) {
		let item = this.getItemByValue(value);

		if (item == null) return;

		item.element.hide();
	}

	showItem(value) {
		let item = this.getItemByValue(value);

		if (item == null) return;

		item.element.show();
	}

	selectItem(value) {
		let item = this.getItemByValue(value);

		if (item == null) return;

		item.element.find('input').attr('checked', 'checked');
	}

	deselectItem(value) {
		let item = this.getItemByValue(value);

		if (item == null) return;

		item.element.find('input').removeAttr('checked');
	}

	search(query) {
		query = query.toLowerCase();

		for (let item of this.items) {
			if (item.isGroup) {
				//If the group label is matched in the search show the whole group
				if (item.label.toLowerCase().indexOf(query) > -1) {
					for (let groupItem of item.items) {
						groupItem.element.show();
					}

					continue;
				}

				let hasFoundItem = false;
				for (let groupItem of item.items) {
					if (groupItem.label.toLowerCase().indexOf(query) == -1) {
						groupItem.element.hide();
					} else {
						hasFoundItem = true;
						groupItem.element.show();
					}
				}

				if (!hasFoundItem) { //Hide the whole group
					item.element.hide();
				} else {
					item.element.show();
				}
			} else {
				if (item.label.toLowerCase().indexOf(query) == -1) {
					item.element.hide();
				} else {
					item.element.show();
				}
			}
		}
	}

	clearSearch() {
		for (let item of this.items) {
			item.element.show();

			if (item.isGroup) {
				for (let groupItem of item.items) {
					groupItem.element.show();
				}
			}
		}
	}
}

module.exports = MultiSelect;